import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Select from 'react-select'
import {
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
} from 'reactstrap'
import find from 'lodash/find'
import get from 'lodash/get'
import shortid from 'shortid'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import DeleteItem from '../../../../static/images/delete-item.svg'
import AddItem from '../../../../static/images/add-item.svg'
import { statusColor } from '../../helpers/color'

// const customStyles = {
//   control: (base) => ({
//     ...base,
//     height: 25,
//     minHeight: 25,
//   }),
//   dropdownIndicator: (base) => ({
//     ...base,
//     width: 15,
//     padding: 0,
//   }),
// }
// const invalidStyles = {
//   control: (base, state) => ({
//     ...base,
//     border: !state.isFocused ? '1px solid #dc3545' : '',
//     background: "#FFFFFF",
//     ...base,
//     height: 25,
//     minHeight: 25,
//   }),
//   dropdownIndicator: (base) => ({
//     ...base,
//     width: 15,
//     padding: 0,
//   }),
// }

export const InfoData = props => {
  const { project, myProjects } = props
  const { isEdit, showApprover } = props
  const { addTask, handleInputMyTimesheet, handleApprover } = props
  const projectData = timesheetHelper.findProject(project.project_id, myProjects)
  const approvers = timesheetHelper.createApproverList(projectData.approvers)
  const approver = find(approvers, { value: project.approver_id })

  return (
    <Wrap>
      <Row>
        <CircleCol>
          <Detail>
            { <Status color={ statusColor(get(project, 'status', CONSTANTS.NONSUBMIT)) } /> }
          </Detail>
        </CircleCol>
        <CodeCol>
          <Detail>{ projectData.project_code }</Detail>
        </CodeCol>
        <FirstCol>
          <Detail>{ projectData.name }</Detail>
        </FirstCol>
        <DeleteCol>
          { isEdit && <Add onClick={ () => addTask(project.key) } /> }
        </DeleteCol>
      </Row>
      <Row>
        <ManagerCol>
          <LocationButton
            style={ {
              height: 28,
              textAlign: 'left',
              color: 'black',
              border: approver ? '1px solid #ced4da' : '1px solid red',
              backgroundColor: isEdit ? 'white' : '#e9ecef',
            } }
            disabled={ !isEdit }
            onClick={ () => handleApprover(project.key) }
          >
            { approver ? approver.label : 'Select Approver' }
          </LocationButton>
          <Modal
            isOpen={ showApprover }
            toggle={ () => handleApprover() }
          >
            <ModalHeader
              toggle={ () => handleApprover() }
            >
              <Header>Select Approver</Header>
            </ModalHeader>
            <ModalBody>
              <SelectLocation
                name='approver_id'
                options={ approvers }
                isDisabled={ !isEdit }
                onChange={ (e) => {
                  handleApprover()
                  handleInputMyTimesheet('approver_id', e, get(props, 'approverKey'))
                } }
                value={ approver }
              />
            </ModalBody>
          </Modal>
        </ManagerCol>
      </Row>
    </Wrap>
  )
}

export const TaskData = props => {
  const { isEdit, showLocation } = props
  const { task, projectID, taskID } = props
  const { deleteTask, handleInputMyTimesheet, handleLocation } = props
  let location = find(props.locations, { value: task.location_id })
  if (location === undefined) {
    location = find(props.locations, { code: 'BKK' })
    if (location) handleInputMyTimesheet('location_id', location, projectID, taskID)
  }
  return (
    <Row>
      <LocationCol>
        <LocationButton
          style={ {
            height: 28,
            textAlign: 'left',
            color: 'black',
            border: '1px solid #ced4da',
            backgroundColor: isEdit ? 'white' : '#e9ecef',
          } }
          disabled={ !isEdit }
          onClick={ () => handleLocation(projectID, taskID) }
        >
          { location ? location.label : 'Select Location' }
        </LocationButton>
        <Modal
          isOpen={ showLocation }
          toggle={ () => handleLocation() }
        >
          <ModalHeader
            toggle={ () => handleLocation() }
          >
            <Header>Select Location</Header>
          </ModalHeader>
          <ModalBody>
            <SelectLocation
              name='location_id'
              options={ props.locations }
              styles={ { menuPortal: base => ({ ...base, zIndex: 9999, fontSize: 12 }) } }
              menuPortalTarget={ document.body }
              menuPosition={ 'fixed' }
              menuPlacement={ 'bottom' }
              onChange={ (e) => {
                handleLocation()
                handleInputMyTimesheet('location_id', e, get(props, 'locationKey'), get(props, 'taskKey'))
              } }
              value={ location }
            />
          </ModalBody>
        </Modal>
      </LocationCol>
      <TaskCol>
        <TaskInput
          key={ shortid() }
          name='task_name'
          placeholder='Task...'
          disabled={ !isEdit }
          defaultValue={ task.task_name }
          onBlur={ (e) => handleInputMyTimesheet('task_name', e, projectID, taskID) }
        />
      </TaskCol>
      <AddCol>
        { isEdit && <Trash onClick={ () => deleteTask(projectID, taskID) } /> }
      </AddCol>
    </Row>
  )
}

InfoData.propTypes = {
  isEdit: PropTypes.bool,
  showApprover: PropTypes.bool,
  myProjects: PropTypes.array,
  project: PropTypes.object,
  handleInputMyTimesheet: PropTypes.func,
  addTask: PropTypes.func,
  handleApprover: PropTypes.func,
}
InfoData.defaultProps = {
  isEdit: false,
  showApprover: false,
  data: {},
  approvers: [],
  myProjects: [],
  project: {},
  handleInputMyTimesheet: () => {},
  deleteProject: () => {},
  addTask: () => {},
  handleApprover: () => {},
}
TaskData.propTypes = {
  isEdit: PropTypes.bool,
  showLocation: PropTypes.bool,
  task: PropTypes.object,
  locations: PropTypes.array,
  projectID: PropTypes.string,
  taskID: PropTypes.number,
  deleteTask: PropTypes.func,
  handleInputMyTimesheet: PropTypes.func,
  handleLocation: PropTypes.func,
}
TaskData.defaultProps = {
  isEdit: false,
  showLocation: false,
  locations: [],
  task: {},
  projectID: '',
  taskID: 0,
  deleteTask: () => {},
  handleInputMyTimesheet: () => {},
  handleLocation: () => {},
}

const Header = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px;
  color: #AD2624;
`
const Add = styled.div`
  background-image: url(${AddItem});
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
`
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 15px;
  width: 15px;
  background-color: #D44B49;
  border-radius: 50%;
  margin-top: 3px;
  cursor: pointer;
`
const Status = styled(Circle)`
  background-color: ${props => props.color};
  height: 10px;
  width: 10px;
`
const LocationButton = styled(Button)`
  margin-top: 0px;
  font-size: 12px;
  font-family: Gotham;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const TaskInput = styled(Input)`
  height: 28px;
  margin-bottom: 10px;
  font-size: 12px;
  font-family: 'Gotham' !important;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 30%;
  @media (max-width: 575.98px) {
    width: 100%;
  }
  @media (max-width: 767.98px) {
    width: 100%;
  }
`
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  margin-left: 2%;
  @media (max-width: 575.98px) {
    width: 100%;
  }
  @media (max-width: 767.98px) {
    width: 100%;
  }
`
const FirstCol = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-top: 10px;
`
const CodeCol = styled(FirstCol)`
  width: 20%;
  padding-right: 5px;
`
const CircleCol = styled(FirstCol)`
  width: 5%;
`
const TaskCol = styled.div`
  width: 60%;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`
const AddCol = styled(TaskCol)`
  width: 10%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
`
const DeleteCol = styled(AddCol)`
  width: 15%;
  margin-top: 10px;
`
const Title = styled.p`
  margin-bottom: 0px;
  font-weight: normal;
`
const Detail = styled(Title)`
  font-size: 12px;
  height: 25px;
  font-family: 'Gotham-Bold' !important;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`
const LocationCol = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  padding-right: 10px;
`
const ManagerCol = styled(LocationCol)`
  width: 95%;
  margin-right: 0px;
  padding-right: 0px;
  margin-top: 10px;
`
const SelectLocation = styled(Select)`
  font-family: 'Gotham' !important;
  width : 100%;
  height : 100%;
  font-size: 12px;
`
const Trash = styled.div`
  background-image: url(${DeleteItem});
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/info-col-mobile.js